/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {
    Text,
    VStack,
    HStack,
} from '@chakra-ui/react';
import { faInfoCircle } from '@fortawesome/sharp-light-svg-icons';
import { FaIcon } from '../fa-icon';

export function SeeMoreSummary({
    name,
    remainingCount,
    hasIcon = true,
}: {
    name: string;
    remainingCount: number;
    hasIcon?: boolean;
}) {
    if (name === '') return null;

    return (
        <HStack align="start">
            {hasIcon && <FaIcon icon={faInfoCircle} color="muted.500" pt={1} />}
            <VStack align="left" gap={0}>
                <Text noOfLines={1} pr={1}>{name}</Text>
                <Text color="muted.500" fontSize="sm">
                    {remainingCount > 0 ? `& ${remainingCount} more` : null}
                </Text>
            </VStack>
        </HStack>
    );
}
